import { all, fork } from 'redux-saga/effects';
import { watchCreateStatusUpdates } from './create';
import { watchDeleteStatusUpdates } from './delete';
import { watchGetStatusUpdates } from './get';
import {
  watchLoadAllStatusUpdates,
  watchLoadStatusUpdates,
  watchStatusUpdatesLoadingState,
} from './load';
import { watchUpdateStatusUpdates } from './update';
import { watchUpdateStatusUpdateTitle } from './update-title';

export const statusUpdatesRootSaga = function* () {
  yield all([
    fork(watchGetStatusUpdates),
    fork(watchUpdateStatusUpdates),
    fork(watchCreateStatusUpdates),
    fork(watchDeleteStatusUpdates),
    fork(watchLoadStatusUpdates),
    fork(watchLoadAllStatusUpdates),
    fork(watchStatusUpdatesLoadingState),
    fork(watchUpdateStatusUpdateTitle),
  ]);
};
